import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { fetchRedFlagsData } from "../../../../redux/prospect-reducers/prospectSlice";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import CmnFilters from "../../common/CmnFilters";

const RedFlagAlerts = ({ userInfoData, showFilters }) => {
  const dispatch = useDispatch();
  const { redFlags, redFlagsLoading } = useSelector(
    (state) => state?.prospects
  );
  console.log("redFlagsLoading", redFlagsLoading);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  // Initial filter states
  const iniAllFilters = {
    selectedGym:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedLeadStage: null,
  };

  const [allFilters, setAllFilters] = useState(iniAllFilters);

  // API filters state
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: iniAllFilters.selectedGym?.value || "",
    lead_stage: iniAllFilters.selectedLeadStage?.value || "",
  };

  const [filters, setFilters] = useState(iniFilters);

  // Filter functions
  const onResetFilters = () => {
    setAllFilters(iniAllFilters);
    setIsPage(0);
  };

  const onClickSearch = () => {
    setFilters({
      ...filters,
      gym_id: allFilters.selectedGym?.value || "",
      lead_stage: allFilters.selectedLeadStage?.value || "",
      page: 1,
      limit: pageLimit,
    });
    setIsPage(0);
  };

  // Sync filters when allFilters change
  useEffect(() => {
    setFilters({
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      lead_stage: allFilters.selectedLeadStage?.value || "",
    });
  }, [
    isPage,
    pageLimit,
    allFilters,
  ]);

  // Sync gym_id when userInfoData changes
  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym:
  //       !isAdmin && !isMarketing && !isClusterManager
  //         ? {
  //             label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //             value:
  //               userInfoData?.gym_id ||
  //               userInfoData?.user_id ||
  //               userInfoData?.uid ||
  //               "",
  //           }
  //         : "",
  //   }));
  // }, [
  //   userInfoData?.gym_id,
  //   isAdmin,
  //   isMarketing,
  //   isClusterManager,
  //   isGym,
  //   userInfoData?.name,
  //   userInfoData?.gym_name,
  //   userInfoData?.user_id,
  //   userInfoData?.uid,
  // ]);

  useEffect(() => {
    if (userInfoData?.token) {
      dispatch(
        fetchRedFlagsData({
          filters,
          token: userInfoData?.token,
        })
      );
    }
  }, [dispatch, userInfoData?.token, filters]);

  const getAlertTypeClass = (type) => {
    switch (type) {
      case "overdue":
        return "alert-overdue";
      case "lost":
        return "alert-lost";
      case "stuck":
        return "alert-stuck";
      case "multiple":
        return "alert-multiple";
      default:
        return "alert-overdue";
    }
  };

  const tableColumns = [
    {
      dataField: "flag_type",
      text: "Alert Type",
      formatter: (cell, row) => (
        <div className="d-flex align-items-center">
          <span className={`redflag-pill ${getAlertTypeClass(row?.flag_type?.toLowerCase().replace(/\s+/g, "-") || "overdue")}`}>
            {cell || "Red Flag Alert"}
          </span>
        </div>
      ),
    },
    {
      dataField: "name",
      text: "Member",
      formatter: (cell) => <span className="fw-medium">{cell || "Unknown"}</span>,
    },
    {
      dataField: "mem_lead_stage",
      text: "Stage",
      formatter: (cell) => {
        const stage = cell || "Unknown";
        
        // Function to get stage pill class
        const getStagePillClass = (stageText) => {
          const stage = stageText.toLowerCase();
          if (stage.includes("fresh")) {
            return "stage-pill stage-pill-fresh";
          } else if (stage.includes("renewal")) {
            return "stage-pill stage-pill-renewal";
          } else if (stage.includes("unpaid")) {
            return "stage-pill stage-pill-unpaid";
          } else if (stage.includes("subscribed")) {
            return "stage-pill stage-pill-subscribed";
          } else {
            return "stage-pill stage-pill-default";
          }
        };
        
        return (
          <span className={getStagePillClass(stage)}>
            {stage}
          </span>
        );
      },
    },
    {
      dataField: "assigned_to_name",
      text: "Agent",
      formatter: (cell) => <span className="minWidth100">{cell || "Unassigned"}</span>,
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (cell) => <span className=" minWidth150">{cell || "Unknown"}</span>,
    },
    {
      dataField: "lead_value",
      text: "Value",
      formatter: (cell) => {
        const value = cell || "0";
        const displayValue = value === "not_set" ? "Not Set" : value;
        return <span className=" minWidth100">₹ {displayValue}</span>;
      },
    },
    {
      dataField: "last_followup_date",
      text: "Last Follow-up",
      formatter: (cell) => <span className=" minWidth100">{cell || "Not Available"}</span>,
    },
    {
      dataField: "followup_count",
      text: "Follow-up Count",
      formatter: (cell) => <span className=" minWidth100 ">{cell || "0"}</span>,
    },
    {
      dataField: "current_followup_status",
      text: "Current Status",
      formatter: (cell) => <span className=" minWidth100">{cell || "Not Available"}</span>,
    },
    {
      dataField: "remarks",
      text: "Description",
      formatter: (cell, row) => (
        <span className=" minWidth150" title={cell}>
          {cell || `Lead in ${row?.mem_lead_stage} stage requires attention`}
        </span>
      ),
    },
  ];

  const paginationArray = redFlags?.status
    ? [{ pagination: redFlags?.total || 0, pages: redFlags?.totalPages || 1 }]
    : [];

  return (
    <div>
      {showFilters && (
        <Row>
          <Col>
            <CmnFilters
              from="red-flag-alerts"
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
          searchFilterApplied={
            (allFilters.selectedGym?.value !== "" && allFilters.selectedGym?.value !== iniAllFilters.selectedGym?.value) ||
            (allFilters.selectedLeadStage?.value !== "" && allFilters.selectedLeadStage?.value !== null)
          }
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          {redFlagsLoading ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 120 }}>
              <ReactVortoxSpinner />
            </div>
          ) : (
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={redFlags?.data || []}
                tableColumns={tableColumns}
                tablePagination={paginationArray}
                isPage={isPage}
                setIsPage={setIsPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RedFlagAlerts;
